import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

import { DropDownComponentBase } from './drop-down.base.component';

import { CommonService } from '../../_services';
import { ICountry, IGeographicRegion, ICity } from '../../_entities';

@Component({
    selector: 'country-dropdown',
    template: require('./dropdown.template.html'),
    styles: ['input[type=text] { margin-top:10px; }']
})
export class CountryDropDownComponent extends DropDownComponentBase<ICountry> {
    constructor(private commonService: CommonService) {
        super();
    }

    getItems(): Promise<ICountry[]> {
        return this.commonService.getCountriesList(true);
    }
    mapItem(items: ICountry[], item: ICountry): any {
        return items.find(x => x.code === item.code);
    }
    onItemSelected(item: ICountry) {
        this.selectedItemChange.emit(item);
    }

    @Input("selectedCountry") set selectedBinding(val: ICountry) {
        if (val != this.selectedItem)
            this.setSelectedItem(val);
    }
    @Output("selectedCountryChange") selectedItemChange = new EventEmitter<ICountry>();
    
    @Input() isDisabled: boolean;
    
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/components/country-dropdown.component.ts